<template>
  <div>
    <hg-dialog title="新增角色" :width="600" :height="400" :visible="show" @close="handleClose">
      <el-form :model="data" :rules="rules" size="mini"  ref="ruleForm" label-width="100px" class="add-box">
        <el-row :gutter="22">
          <el-col :span="22">
            <el-form-item label="角色名称" prop="name">
              <el-input v-model="data.name" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="11">
            <el-form-item label="是否启用" prop="select">
              <el-switch
                v-model="data.statu"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="权限管理">
          <div class="authority-box">
            <authority :authorityTree="authorityTree" @checkedArr="checkedArr" v-if="dialogVisible"></authority>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="hg-dialog-footer">
        <el-button type="primary" @click="submit" size="small" icon="el-hg-icon-save">保 存</el-button>
        <el-button @click="handleClose" size="small" icon="el-hg-icon-close">关 闭</el-button>
      </span>
    </hg-dialog>
  </div>
</template>
<script>
import authority from '../comm/authority';
import HgDialog from '@/components/dialog';

export default {
  name: 'add',
  components: {
    authority,
    HgDialog
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    authorityTree: {
      type: Array
    }
  },
  data() {
    return {
      dialogVisible: false,
      rules: {
        name: [{
          required: true,
          message: '请输入角色名称',
          trigger: 'blur'
        }]
      },
      data: {
        name: '',
        functionId: '',
        resourceId: '',
        updateFlg: 'add'
      }
    };
  },
  methods: {
    checkedArr(params) {
      this.data.functionId = params.functionId.join(',');
      this.data.resourceId = params.resourceId.join(',');
    },
    submit() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.data.state = this.data.statu? 1 : 0;
          this.saveRole();
        }
        else {
          console.warn('error submit!!');
          return false;
        }
      });
    },
    async saveRole() {
      const res = await this.$services.postJson({
        type: 'ROLEMANGEMENT',
        url: 'saveRole',
        params: JSON.parse(JSON.stringify(this.data))
      });
      if (res.code === '000') {
        this.$toaster.ok('保存成功');
        this.handleClose();
        this.$emit('refresh');
      }
      else {
        this.$toaster.error(res.msg);
      }
    },
    handleClose() {
      this.$refs['ruleForm'].resetFields();
      this.dialogVisible = false;
      this.$emit('close');
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.dialogVisible = true;
      }
    }
  }
};
</script>
